import React, { useState, useEffect } from 'react'
import { Button, Popover } from '@material-ui/core'
import Calendar from 'react-calendar'
import EventIcon from '@material-ui/icons/Event'
import { COLORES } from '../../../../config/colores'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  buttonDatePicker: {
    justifyContent: 'space-between',
    padding: 0,
    width: '100%',

    '@media (min-width: 780px)': {
      justifyContent: 'center',
      padding: 'inherit',
      width: '98%'
    }
  },
  titleLabel: {
    textAlign: 'left',
    fontSize: '0.9rem',
    color: COLORES.grey.dark,
    margin: '0 auto',

    '@media (min-width: 780px)': {
      textAlign: 'center',
      margin: 0,
      marginBottom: 10
    }
  }
}))

function DatePicker (props) {
  const { selectRange, locale, disabledPast = false, disabledFuture = false, titulo, fechaDesde = null, fechaHasta = null } = props
  const [fechaD, setFechaD] = useState(new Date().toLocaleDateString())
  const [fechaH, setFechaH] = useState(new Date().toLocaleDateString())
  const classes = useStyles()

  useEffect(() => {
    if (fechaDesde && fechaHasta) {
      setFechaD(fechaDesde)
      setFechaH(fechaHasta)
    }
  }, [fechaDesde, fechaHasta])

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleOpen = (e) => { setAnchorEl(e.currentTarget) }
  const handleClose = () => { setAnchorEl(null) }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handleDateChange = (date) => {
    const fechaDesde = selectRange ? date[0] : date
    const fechaHasta = selectRange ? date[1] : date
    setFechaD(fechaDesde.toLocaleDateString())
    setFechaH(fechaHasta.toLocaleDateString())
    handleClose()
    props.onDateChange(new Date(fechaDesde), new Date(fechaHasta))
  }

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <div style={{ paddingTop: '22px', backgroundColor: COLORES.blue.primary, width: '350px' }}>
          <Calendar
            className='calendar-react'
            onChange={handleDateChange}
            selectRange={selectRange}
            locale={locale}
            minDate={disabledPast ? new Date() : null}
            maxDate={disabledFuture ? new Date() : null}
          />
        </div>
      </Popover>

      <h6 className={classes.titleLabel}>{titulo}</h6>
      <Button
        style={{
          margin: '0 auto',
          color: 'rgb(57 48 48)',
          borderBottom: '1.8px solid',
          borderRadius: 0,
          fontSize: '1rem',
          borderColor: '#9a9b9d',
          outline: 'none'
        }}
        className={classes.buttonDatePicker}
        endIcon={<EventIcon style={{ fontSize: '1.4rem', color: '#495057' }} />}
        onClick={handleOpen}
        type='input'
        size='medium'
        aria-describedby={id}
      >
        { (fechaD === fechaH)
          ? fechaD
          : `${fechaD} - ${fechaH}`
        }
      </Button>
    </>

  )
}

export default DatePicker
